"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.ZeroDevPluginSafe__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_entryPoint",
                type: "address"
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "result",
                type: "bytes"
            },
        ],
        name: "QueryResult",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "owner",
                type: "address"
            },
        ],
        name: "AddedOwner",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "approvedHash",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
        ],
        name: "ApproveHash",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "handler",
                type: "address"
            },
        ],
        name: "ChangedFallbackHandler",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "guard",
                type: "address"
            },
        ],
        name: "ChangedGuard",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "threshold",
                type: "uint256"
            },
        ],
        name: "ChangedThreshold",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "module",
                type: "address"
            },
        ],
        name: "DisabledModule",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "module",
                type: "address"
            },
        ],
        name: "EnabledModule",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "txHash",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "payment",
                type: "uint256"
            },
        ],
        name: "ExecutionFailure",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "module",
                type: "address"
            },
        ],
        name: "ExecutionFromModuleFailure",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "module",
                type: "address"
            },
        ],
        name: "ExecutionFromModuleSuccess",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "txHash",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "payment",
                type: "uint256"
            },
        ],
        name: "ExecutionSuccess",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "owner",
                type: "address"
            },
        ],
        name: "RemovedOwner",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
        ],
        name: "SafeReceived",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "initiator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "owners",
                type: "address[]"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "threshold",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "address",
                name: "initializer",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "fallbackHandler",
                type: "address"
            },
        ],
        name: "SafeSetup",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "msgHash",
                type: "bytes32"
            },
        ],
        name: "SignMsg",
        type: "event"
    },
    {
        stateMutability: "nonpayable",
        type: "fallback"
    },
    {
        inputs: [],
        name: "VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_threshold",
                type: "uint256"
            },
        ],
        name: "addOwnerWithThreshold",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hashToApprove",
                type: "bytes32"
            },
        ],
        name: "approveHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
        ],
        name: "approvedHashes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_threshold",
                type: "uint256"
            },
        ],
        name: "changeThreshold",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dataHash",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "signatures",
                type: "bytes"
            },
            {
                internalType: "uint256",
                name: "requiredSignatures",
                type: "uint256"
            },
        ],
        name: "checkNSignatures",
        outputs: [],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dataHash",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "signatures",
                type: "bytes"
            },
        ],
        name: "checkSignatures",
        outputs: [],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "prevModule",
                type: "address"
            },
            {
                internalType: "address",
                name: "module",
                type: "address"
            },
        ],
        name: "disableModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "domainSeparator",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address"
            },
        ],
        name: "enableModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8"
            },
            {
                internalType: "uint256",
                name: "safeTxGas",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "baseGas",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "gasPrice",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "gasToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "refundReceiver",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_nonce",
                type: "uint256"
            },
        ],
        name: "encodeTransactionData",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "entryPoint",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8"
            },
            {
                internalType: "uint256",
                name: "safeTxGas",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "baseGas",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "gasPrice",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "gasToken",
                type: "address"
            },
            {
                internalType: "address payable",
                name: "refundReceiver",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "signatures",
                type: "bytes"
            },
        ],
        name: "execTransaction",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool"
            },
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8"
            },
        ],
        name: "execTransactionFromModule",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8"
            },
        ],
        name: "execTransactionFromModuleReturnData",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "returnData",
                type: "bytes"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8"
            },
        ],
        name: "executeAndRevert",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "start",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "pageSize",
                type: "uint256"
            },
        ],
        name: "getModulesPaginated",
        outputs: [
            {
                internalType: "address[]",
                name: "array",
                type: "address[]"
            },
            {
                internalType: "address",
                name: "next",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getOwners",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "offset",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "length",
                type: "uint256"
            },
        ],
        name: "getStorageAt",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8"
            },
            {
                internalType: "uint256",
                name: "safeTxGas",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "baseGas",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "gasPrice",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "gasToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "refundReceiver",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_nonce",
                type: "uint256"
            },
        ],
        name: "getTransactionHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address"
            },
        ],
        name: "isModuleEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
        ],
        name: "isOwner",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_hash",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes"
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "nonce",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_plugin",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes"
            },
        ],
        name: "queryPlugin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "prevOwner",
                type: "address"
            },
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_threshold",
                type: "uint256"
            },
        ],
        name: "removeOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8"
            },
        ],
        name: "requiredTxGas",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "handler",
                type: "address"
            },
        ],
        name: "setFallbackHandler",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "guard",
                type: "address"
            },
        ],
        name: "setGuard",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_owners",
                type: "address[]"
            },
            {
                internalType: "uint256",
                name: "_threshold",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "address",
                name: "fallbackHandler",
                type: "address"
            },
            {
                internalType: "address",
                name: "paymentToken",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "payment",
                type: "uint256"
            },
            {
                internalType: "address payable",
                name: "paymentReceiver",
                type: "address"
            },
        ],
        name: "setup",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
        ],
        name: "signedMessages",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "targetContract",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "calldataPayload",
                type: "bytes"
            },
        ],
        name: "simulateAndRevert",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "prevOwner",
                type: "address"
            },
            {
                internalType: "address",
                name: "oldOwner",
                type: "address"
            },
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            },
        ],
        name: "swapOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256"
                    },
                    {
                        internalType: "bytes",
                        name: "initCode",
                        type: "bytes"
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes"
                    },
                    {
                        internalType: "uint256",
                        name: "callGasLimit",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "verificationGasLimit",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "preVerificationGas",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "maxFeePerGas",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "maxPriorityFeePerGas",
                        type: "uint256"
                    },
                    {
                        internalType: "bytes",
                        name: "paymasterAndData",
                        type: "bytes"
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes"
                    },
                ],
                internalType: "struct UserOperation",
                name: "userOp",
                type: "tuple"
            },
            {
                internalType: "bytes32",
                name: "userOpHash",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "missingAccountFunds",
                type: "uint256"
            },
        ],
        name: "validateUserOp",
        outputs: [
            {
                internalType: "uint256",
                name: "validationData",
                type: "uint256"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    },
];
var _bytecode = "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";
var isSuperArgs = function (xs) { return xs.length > 1; };
var ZeroDevPluginSafe__factory = /** @class */ (function (_super) {
    __extends(ZeroDevPluginSafe__factory, _super);
    function ZeroDevPluginSafe__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    ZeroDevPluginSafe__factory.prototype.deploy = function (_entryPoint, overrides) {
        return _super.prototype.deploy.call(this, _entryPoint, overrides || {});
    };
    ZeroDevPluginSafe__factory.prototype.getDeployTransaction = function (_entryPoint, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _entryPoint, overrides || {});
    };
    ZeroDevPluginSafe__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ZeroDevPluginSafe__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ZeroDevPluginSafe__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    ZeroDevPluginSafe__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    ZeroDevPluginSafe__factory.bytecode = _bytecode;
    ZeroDevPluginSafe__factory.abi = _abi;
    return ZeroDevPluginSafe__factory;
}(ethers_1.ContractFactory));
exports.ZeroDevPluginSafe__factory = ZeroDevPluginSafe__factory;
